

import styled from "styled-components";







const Geral = styled.div`
  max-width: 100%;

  
  background-color: transparent;
  border-radius: 12px;
  box-shadow: 0px 0px 2px #ccc;


  @media (max-width:1367px) {
    margin: 5px;
    box-shadow: none;

  }

  @media (max-width: 1024px) {
    margin: 5px;
    box-shadow: none;
    margin-bottom: 100px;
  }


`;

const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  width: 98%;   
  margin: auto;   
  padding: 12px;
`;

export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;

const Thead = styled.thead`
  background-color: #fff;

`;


export const Tbody = styled.tbody`
  background-color: #fefefe;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  
  ${({ noHover }) =>
    !noHover &&
    `
    &:hover {
      background-color: #f5f5f5;
    }
  `}

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const TrHead = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const Th = styled.th`
  color: #575757;
  padding: 18px 10px;
  font-size: 18px;
  text-align: center;
  font-weight: bold;

  cursor: pointer;
  &.hide-on-mobile {
    @media (max-width: 1024px) {
      display: none;
    }
  }





  @media (max-width: 1367px) {
    padding: 6px 5px;
    font-size: 12px;
  }
  @media (max-width: 1024px) {
    padding: 6px 5px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }
`;



export const Td = styled.td`
  padding: 25px 10px;

  font-size: 18px;
  color: #575757;
  background-color: ${(props) => props.zebra ? "#f2f2f2" : "transparent"};
    text-align: center;
  white-space: nowrap; 
  overflow: hidden;     
  text-overflow: ellipsis; 

  &.mobile-hide {
    @media (max-width: 1024px) {
      display: none;
    }
  }
  @media (max-width: 1367px) {
    padding: 6px;
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    padding: 6px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }

`;

export const CabecalhoTabela = styled.th`
  text-align: center;
  
  padding: 18px;
  color: white;

  h2{
    font-size: 2rem;
  }

  padding{
    font-size: 1.4rem;
  }

  
`;




const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;




const Grid = ({ showGrid, isLoading, equipamentoDetalhes, verDetalhesEquipamento }) => {

  const detalhesFiltrados = Array.isArray(equipamentoDetalhes)
    ? equipamentoDetalhes.filter(item =>
      Number(item.COD_EQUIPAMENTO) === Number(verDetalhesEquipamento)
    )
    : [];


  console.log(detalhesFiltrados)

  return (
    <>

      <Geral>
        <div>

          {isLoading ? (
            <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
          ) : (
            <>


              {showGrid && (

                <>


                  {detalhesFiltrados.length === 0 ? (
                    <Tr>
                      <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
                        Nenhum detalhe encontrado.
                      </Td>
                    </Tr>
                  ) : (
                    <TableWrapper>
                      <Table>
                        <thead>
                          <tr>
                            <th>
                              Frota
                            </th>

                            <th >
                              Entrada Cana
                            </th>

                            <th >
                              Operação
                            </th>

                            <th >
                              Campo Alterado
                            </th>
                            <th >
                              Valor Antigo
                            </th>
                            <th >
                              Valor Novo
                            </th>
                            <th >
                              Data/Hora
                            </th>

                          </tr>
                        </thead>

                        <tbody>
                          {detalhesFiltrados.map((item, i) => (
                            <tr key={i}>
                              <td>{item.COD_EQUIPAMENTO}</td>
                              <td>{item.COD_SAFRA}/{item.COD_ENTRADA}</td>
                              <td>{item.DESC_OPERACAO}</td>
                              <td>{item.CAMPO_ALTERADO}</td>
                              <td>{item.VALOR_ANTIGO ?? '-'}</td>
                              <td>{item.VALOR_NOVO ?? '-'}</td>
                              <td>{new Date(item.DATA_HORA).toLocaleString('pt-BR')}</td>

                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </TableWrapper>

                  )}

                </>
              )}
            </>
          )}






        </div>

      </Geral >

    </>

  );
};



export default Grid;
